export function resolvePlan(nb, plan, myCookbooks) {
  const p = plan[nb] || {};
  const title = (p.title ?? nb).trim() || nb;
  const renamed = title.toLowerCase() !== nb.toLowerCase();
  const match = !renamed && !p.optOut ? myCookbooks.find((c) => (c.title || "").trim().toLowerCase() === nb.trim().toLowerCase()) : null;
  return { title, renamed, match, hasMatch: !!myCookbooks.find((c) => (c.title || "").trim().toLowerCase() === nb.trim().toLowerCase()) };
}

export function SplitToggle({ on, onChange }) {
  return (
    <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 cursor-pointer" data-testid="import-split-toggle-label">
      <input type="checkbox" className="w-4 h-4 accent-rf-orange" checked={on} onChange={(e) => onChange(e.target.checked)} data-testid="import-split-toggle" />
      One cookbook per notebook
    </label>
  );
}

export function DupeSummary({ count, ticked, onUntick }) {
  if (!count) return null;
  return (
    <div className="px-5 py-3 bg-sky-50 border-b border-sky-200 text-sm text-sky-900 flex flex-wrap items-center gap-3" data-testid="import-dupe-summary">
      <span className="flex-1 min-w-[240px]"><b>{count}</b> {count === 1 ? "recipe has a title" : "recipes have titles"} already in your account. {ticked ? `${ticked} ${ticked === 1 ? "is" : "are"} ticked and will be imported as extra copies.` : "They're unticked, so they'll be skipped — tick any you still want."}</span>
      {ticked > 0 && <button type="button" onClick={onUntick} data-testid="import-untick-dupes"
              className="px-3 py-1.5 rounded-full bg-white border border-sky-300 text-sky-800 text-xs font-bold hover:bg-sky-100">Untick all duplicates</button>}
    </div>
  );
}

export function DupeBadge({ books, i }) {
  if (!books?.length) return null;
  return (
    <span className="ml-2 inline-block rounded-full bg-sky-100 text-sky-800 text-[11px] font-bold px-2 py-0.5 align-middle" data-testid={`import-dupe-badge-${i}`}>
      Already in your account · {books.slice(0, 2).map((b) => `“${b}”`).join(", ")}{books.length > 2 ? ` +${books.length - 2}` : ""}
    </span>
  );
}
